import { render } from "./intangibleMuseum.vue?vue&type=template&id=65073c5e&scoped=true"
import script from "./intangibleMuseum.vue?vue&type=script&lang=js"
export * from "./intangibleMuseum.vue?vue&type=script&lang=js"

import "./intangibleMuseum.vue?vue&type=style&index=0&id=65073c5e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65073c5e"]])

export default __exports__